
export const menuItems = [
    {
        id: 1,
        label: 'module.domain',
        link: '/domain',
        permissionCodes: ['DOMAIN_READ'],
    },
    {
        id: 5,
        label: 'module.domainGroup',
        link: '/domain-group',
        permissionCodes: ['DOMAIN_READ'],
    },
    {
        id: 2,
        label: 'module.user',
        link: '/user',
        permissionCodes: ['USER_READ', 'USER_CREATE'],
    },
    {
        id: 3,
        label: 'module.roles',
        link: '/role',
        permissionCodes: ['ROLE_READ', 'ROLE_CREATE'],
    },
    {
        id: 4,
        label: 'module.configuration',
        link: '/configuration',
        permissionCodes: ['CONFIG_READ'],
    },
]
